import { render, staticRenderFns } from "./AllClueTask.vue?vue&type=template&id=a8279fbc&"
import script from "./AllClueTask.vue?vue&type=script&lang=js&"
export * from "./AllClueTask.vue?vue&type=script&lang=js&"
import style0 from "./AllClueTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports